import { Sanitize } from '@99designs/ninedown';

// Traverses JSON object and sanitizes strings using Sanitize.
// https://gitlab.com/vistaprint-org/99designs/ninedown/blob/master/ts/src/Sanitize.ts
export function sanitizeData(data: any): any {
    if (!Array.isArray(data) && typeof data === 'object') {
        const sanitizedData = { ...data };
        for (const key of Object.keys(sanitizedData)) {
            sanitizedData[key] = sanitizeData(data[key]);
        }
        return sanitizedData;
    }

    if (Array.isArray(data)) {
        return data.map(sanitizeData);
    }

    if (typeof data === 'string') {
        return Sanitize(data);
    }
    return data;
}
